module.exports = __webpack_public_path__ + "static/media/digitos.915edcc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/DTMF/digitos.svg
// module id = 1764
// module chunks = 0